import { useRef, useState } from 'react';
import "./DiscountBanner.css";

const DiscountBanner = () => {

    const [open, setOpen] = useState(false);
    const [hidden, setHidden] = useState(false);

    const hoverTimer = useRef(null);

    // ================= HIDE BANNER =================
    const hideBanner = () => {
        setHidden(true);
    };

    // ================= OPEN PANEL =================
    const openPanel = () => {

        hoverTimer.current = setTimeout(() => {
            setOpen(true);
        }, 200);
    };

    // ================= CLOSE PANEL =================
    const closePanel = () => {

        clearTimeout(hoverTimer.current);
        setOpen(false);
    };

    // ================= HANDLE IMAGE CLICK =================
    // const handleImageClick = (e) => {

    //     const rect = e.target.getBoundingClientRect();

    //     const x = e.clientX - rect.left;
    //     const y = e.clientY - rect.top;

    //     const width = rect.width;
    //     const height = rect.height;

    //     // ================= INSTAGRAM =================
    //     if (
    //         x > width * 0.12 &&
    //         x < width * 0.82 &&
    //         y > height * 0.24 &&
    //         y < height * 0.38
    //     ) {
    //         window.open(
    //             "https://www.instagram.com/ghayar.ae/",
    //             "_blank"
    //         );
    //         return;
    //     }

    //     // ================= TIKTOK =================
    //     if (
    //         x > width * 0.12 &&
    //         x < width * 0.82 &&
    //         y > height * 0.40 &&
    //         y < height * 0.54
    //     ) {
    //         window.open(
    //             "https://www.tiktok.com/@ghayar.ae",
    //             "_blank"
    //         );
    //         return;
    //     }

    //     // ================= LINKEDIN =================
    //     if (
    //         x > width * 0.12 &&
    //         x < width * 0.82 &&
    //         y > height * 0.56 &&
    //         y < height * 0.70
    //     ) {
    //         window.open(
    //             "https://www.linkedin.com/company/ghayar",
    //             "_blank"
    //         );
    //         return;
    //     }

    //     // ================= CLOSE BUTTON =================
    //     if (
    //         x > width * 0.87 &&
    //         y < height * 0.12
    //     ) {
    //         hideBanner();
    //     }
    // };

    const handleImageClick = (e) => {
        window.location.href = "/Spare-Parts/PartsByBrand/475-BORG%20%26%20BECK"
        hideBanner();
    }

    // ================= HANDLE GIF CLICK =================
    const handleButtonClick = (e) => {

        const rect = e.target.getBoundingClientRect();

        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const width = rect.width;
        const height = rect.height;

        // 👉 RIGHT CENTER CLICK = HIDE
        if (
            x > width * 0.65 &&
            y > height * 0.30 &&
            y < height * 0.70
        ) {
            hideBanner();
            return;
        }

        // 👉 OTHERWISE OPEN PANEL
        openPanel();
    };

    // ================= HIDE COMPONENT =================
    if (hidden) return null;

    return (
        <>
            {open && (
                <div
                    className="side-overlay"
                    onClick={closePanel}
                />
            )}

            <div
                className={`side-unit ${open ? "open" : ""}`}
                onMouseLeave={closePanel}
            >

                {/* LEFT PANEL */}
                <div className="side-panel">

                    <img
                        src="/assets/images/banners/borge.png"
                        alt="discount"
                        onClick={handleImageClick}
                        className="social-banner-img"
                        style={{ cursor: "pointer" }}
                    />

                </div>

                {/* RIGHT GIF BUTTON */}
                <div
                    className="side-btn"
                    onMouseEnter={openPanel}
                >

                    <img
                        src="/assets/images/banners/button_img.gif"
                        alt="discount"
                        onClick={handleButtonClick}
                        style={{ cursor: "pointer" }}
                    />

                </div>

            </div>
        </>
    )
}

export default DiscountBanner;